<template>
  <div class="add">
    <div class="d d_list d_list2">
      <div class="d bar">
        <p class="a_back"><i class="iC i_back" @click="goBack"></i></p>
      </div>
    </div>
    <van-form @submit="onSubmit">
      <div class="d d_list">
        <div class="d d_sel d_sel2 inp_pad username">
          <van-field
            v-model="userName"
            name="userName"
            label="用户名"
            :placeholder="placeholderTxt"
          />
        </div>
        <div class="d d_sel d_sel2 inp_pad username">
          <van-field
            v-model="password"
            type="password"
            name="password"
            label="密码"
            maxlength="12"
            placeholder="必须为8~12为字母和数字的组合，区分大小写"
          />
        </div>

        <select-item
          title="级别"
          :value="roleValue"
          :list="conditionInfo.roleList"
          :handlerSelect="selectRole"
          name="roleName"
        ></select-item>
        <comp-address
        :province="province"
        :city="city"
        :district="district"
        :provinceCode="provinceCode"
        :cityCode="cityCode"
        :districtCode="districtCode"
        :selectArea="selectArea"
      ></comp-address>
      </div>

      <div class="d d_bjsm">
        <p>说明∶</p>
        <p>1.全国账号无须指定地区</p>
        <p>2.省、市级账号须指定到所属省或市</p>
        <p>3.区县级账号须指定到所属区县</p>
      </div>
      <div class="add-save">
        <van-button round block type="info" native-type="submit" class="btn btn_bc"
          >保存</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { useStore } from "vuex";

import { useRouter } from "vue-router";
import { getAccountInfo, addAccount } from "@/service/user";
import compAddress from "@/components/Address";
import SelectItem from "@/components/SelectItem";
import { tipsMsg, REG_PWD, getLocal } from "@/common/js";

export default {
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      title: "添加成员账号",
      province: "不限",
      city: "不限",
      district: "不限",
      provinceCode: "100000",
      cityCode: "",
      districtCode: "",

      password: "",
      userName: "",
      roleId: "",
      roleValue: "请选择级别",
      conditionInfo: {},
      areaList: {}, // 数据格式见 Area 组件文档
      showRoleChoice: false,
      placeholderTxt: '请填写用户名'
    });
    const initData = () => {
      // 回显省市区
      const {
        roleList,
        province,
        provinceCode,
        city,
        cityCode,
        district,
        districtCode,
      } = store.state.info;

      if (roleList.length > 0) {
        state.roleList = roleList;
      }
      if (province != null) {
        state.province = province;
        state.provinceCode = provinceCode;
      }
      if (city != null) {
        state.city = city;
        state.cityCode = cityCode;
      }
      if (district != null) {
        state.district = district;
        state.districtCode = districtCode;
      }
    };
    onMounted(async () => {
      createAccountCondition();
      initData();
      const roidId = await getLocal("dsj_roleId");
      if(roidId == 6) {
        state.placeholderTxt = '请填写学校代码'
      }
    });
    const selectRole = (item) => {
      state.roleValue = item.roleName;
      state.roleId = item.roleId;
    };

    // 添加账号的条件
    const createAccountCondition = async () => {
      const { code, data } = await getAccountInfo();
      if (code === 10000 && data) {
        state.conditionInfo = data;
      }
    };

    const goBack = () => {
      router.go(-1);
      // router.push({ path: "/organization/adminAccount" });
    };

    // 选择省市区
    const selectArea = (area) => {
      console.log("selectArea", area);
      // 合并
      Object.assign(state, area);
    };
    const onSubmit = async (values) => {
      const { password, userName } = values;
      const {
        city,
        district,
        province,
        roleId,
        provinceCode,
        cityCode,
        districtCode,
        placeholderTxt,
      } = state;
      if (!userName) {
        tipsMsg("提示", placeholderTxt);
        return false;
      }
      //  else if (!REG_ZM.test(userName)) {
      //   tipsMsg("提示", "用户名必须为字母和数字的组合，区分大小写");
      //   return false;
      // }

      if (!password) {
        tipsMsg("提示", "请输入密码");
        return false;
      } else if (!REG_PWD.test(password)) {
        tipsMsg("提示", "密码必须由8~12位字母和数字的组合，区分大小写");
        return false;
      }
      if (!roleId) {
        tipsMsg("提示", "请选择级别");
        return false;
      }
      if (!province || province == "不限") {
        tipsMsg("提示", "请选择省");
        return false;
      }
      if (!city || city == "不限") {
        tipsMsg("提示", "请选择市");
        return false;
      }
      if (!district || district == "不限") {
        tipsMsg("提示", "请选择区");
        return false;
      }

      const params = {
        city,
        cityCode,
        district,
        districtCode,
        password,
        province,
        provinceCode,
        roleId,
        userName,
      };
      console.log("submit -> ", params);
      const { code } = await addAccount(params);
      if (code === 10000) {
        tipsMsg("提示", "提交成功");
      }
    };
    return {
      ...toRefs(state),
      onSubmit,
      selectRole,
      selectArea,
      goBack,
    };
  },
  components: {
    compAddress,
    SelectItem,
    // sHeader,
  },
};
</script>
<style lang="less" scoped>
.inp_pad {
  padding: 0.133rem 0;
}
// .van-button {
  // font-size: 0.48rem;
  // color: #fff;
  // width: 8rem;
  // height: 1.28rem;
  // line-height: 1.28rem;
  // border-radius: 0.213rem;
// }
.van-cell {
  padding: 0;
  align-items: center;
  background-color: transparent;
  font-size: 0.48rem;
  height: 1.067rem;
  line-height: 1.067rem;
  color: #333;
}
.van-field__control {
  font-size: 0.347rem;
  width: 82%;
  border: none;
  outline: none;
  height: 1.067rem;
  line-height: 1.067rem;
}

:deep(.van-field__label) {
  width: 56px;
}
.username {
  font-size: 0.48rem;
  height: 1.067rem;
  line-height: 1.067rem;
  padding: 0 1.067rem 0 0.4rem;
  margin: 0 0.133rem;
  background: #fff;
  // box-shadow: 0 0 0.267rem #e9f0ff;
   box-shadow: 0 0 0.267rem rgb(255 154 152 / 20%);
  border-radius: 0.107rem;
  padding: 0 1.067rem 0 0.4rem;
}
:deep(.van-field__control) {
  font-size: 0.347rem;
}
.d_list2 {
  background: #fff;
}
.add-save {
  display: flex;
  justify-content: center;
}
</style>
